export default __webpack_public_path__ + "static/media/easy-tether-back.087fa633.svg";